module.exports = __webpack_public_path__ + "static/media/speech_02.c787e5f7.svg";